import { TYPE } from '../../constants'
import { GtmCatchAwardClickModel } from '../../models'
import { BaseBuilder } from '../base.builder/base.builder'

export class CatchAwardClickBuilder extends BaseBuilder {
  constructor(data) {
    const models = new Map([[TYPE.GTM_4, GtmCatchAwardClickModel]])
    super(models, data)
  }
}
